import React from "react";

export function IconPlayingStatus({
  player,
  wrapperStyle = "block h-2.5 w-2.5",
}) {
  if (!player) return null;

  switch (player.playingStatus) {
    case 0:
      return null;
    case 1: // Playing
    case 2: // PlayingBench
      return (
        <span className={wrapperStyle} title="Playing">
          <svg
            className="h-full w-full text-green-400 dark:text-green-500"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="400" cy="400" r="400" fill="currentColor" />
            <path
              d="M573.04 246.475L335.544 483.973L226.96 375.389C214.155 362.587 193.397 362.587 180.592 375.389C167.789 388.194 167.789 408.952 180.592 421.757L312.36 553.526C318.763 559.926 327.153 563.128 335.544 563.128C343.935 563.128 352.326 559.926 358.728 553.526L619.408 292.845C632.211 280.04 632.211 259.282 619.408 246.477C606.603 233.672 585.843 233.672 573.04 246.475Z"
              fill="white"
            />
          </svg>
        </span>
      );

    case 4: // ExtendedBench
      return (
        <span
          className={wrapperStyle}
          title="Extended Bench - Await final teams"
        >
          <svg
            className="h-full w-full text-amber-500"
            viewBox="0 0 800 800"
            fill="none"
          >
            <path
              d="M400.056 162C331.652 162 276 217.654 276 286.058C276 300.039 287.334 311.375 301.316 311.375C315.299 311.375 326.633 300.039 326.633 286.058C326.633 245.572 359.57 212.633 400.056 212.633C440.542 212.633 473.48 245.572 473.48 286.058C473.48 309.343 456.642 324.91 428.903 347.778C403.514 368.707 374.74 392.432 374.74 430.147V511.37C374.74 525.349 386.076 536.687 400.056 536.687C414.037 536.687 425.373 525.349 425.373 511.37V430.147C425.373 416.31 441.938 402.656 461.111 386.844C489.18 363.703 524.111 334.903 524.111 286.058C524.113 217.652 468.459 162 400.056 162Z"
              fill="currentColor"
            />
            <path
              d="M400.056 573.373C382.149 573.373 367.583 587.941 367.583 605.849C367.583 623.753 382.149 638.321 400.056 638.321C417.962 638.321 432.53 623.753 432.53 605.849C432.53 587.941 417.962 573.373 400.056 573.373Z"
              fill="currentColor"
            />
            <path
              d="M400.003 0C179.44 0 0 179.438 0 399.997C0 620.557 179.44 799.995 400.003 799.995C620.562 799.995 800 620.557 800 399.997C800 179.438 620.562 0 400.003 0ZM400.003 734.421C215.597 734.421 65.5733 584.403 65.5733 399.997C65.5733 215.595 215.597 65.5733 400.003 65.5733C584.405 65.5733 734.427 215.595 734.427 399.997C734.427 584.403 584.405 734.421 400.003 734.421Z"
              fill="currentColor"
            />
          </svg>
        </span>
      );

    case 3: // PlayingSub
    case 7: // PlayingSubbedOn
      return (
        <span className={wrapperStyle} title="Starting Sub">
          <svg
            className="h-full w-full text-red-500 dark:text-red-500"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              id="primary"
              d="M20,9a1,1,0,0,1-1-1V4a2,2,0,0,0-2-2H14.82a2,2,0,0,0-2,1.61L12,7.9l-.86-4.29A2,2,0,0,0,9.18,2H7A2,2,0,0,0,5,4V8A1,1,0,0,1,4,9a1,1,0,0,0-1,1V20a2,2,0,0,0,2,2h6a2,2,0,0,0,1-.28A2,2,0,0,0,13,22h6a2,2,0,0,0,2-2V10A1,1,0,0,0,20,9Z"
              fill="currentColor"
            ></path>
            <path
              className="text-white"
              id="secondary"
              d="M16,14H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Zm1,3a1,1,0,0,0-1-1H8a1,1,0,0,0,0,2h8A1,1,0,0,0,17,17Z"
              fill="white"
            ></path>
          </svg>
        </span>
      );

    case 6: // PlayingSubbedOff
      return (
        <span className={wrapperStyle} title="Subbed Off">
          <svg
            className="h-full w-full text-orange-400 dark:text-orange-500"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              id="primary"
              d="M20,9a1,1,0,0,1-1-1V4a2,2,0,0,0-2-2H14.82a2,2,0,0,0-2,1.61L12,7.9l-.86-4.29A2,2,0,0,0,9.18,2H7A2,2,0,0,0,5,4V8A1,1,0,0,1,4,9a1,1,0,0,0-1,1V20a2,2,0,0,0,2,2h6a2,2,0,0,0,1-.28A2,2,0,0,0,13,22h6a2,2,0,0,0,2-2V10A1,1,0,0,0,20,9Z"
              fill="currentColor"
            ></path>
            <path
              className="text-white"
              id="secondary"
              d="M16,14H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Zm1,3a1,1,0,0,0-1-1H8a1,1,0,0,0,0,2h8A1,1,0,0,0,17,17Z"
              fill="white"
            ></path>
          </svg>
        </span>
      );

    case 5: // Emergency
      return (
        <span className={wrapperStyle} title="Emergency">
          <svg
            className="h-full w-full text-red-600 dark:text-red-500"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M400.003 0C179.44 0 0 179.438 0 399.997C0 620.557 179.44 799.995 400.003 799.995C620.562 799.995 800 620.557 800 399.997C800 179.438 620.562 0 400.003 0ZM400.003 734.421C215.597 734.421 65.5733 584.403 65.5733 399.997C65.5733 215.595 215.597 65.5733 400.003 65.5733C584.405 65.5733 734.427 215.595 734.427 399.997C734.427 584.403 584.405 734.421 400.003 734.421Z"
              fill="currentColor"
            />
            <path
              d="M497.12 283.798H342.599V366.799H484.879C495.35 366.799 503.126 369.182 508.207 373.947C513.442 378.558 516.06 384.706 516.06 392.392C516.06 400.077 513.519 406.379 508.438 411.297C503.357 416.062 495.504 418.445 484.879 418.445H342.599V514.588H502.433C513.212 514.588 521.296 517.124 526.685 522.196C532.228 527.115 535 533.724 535 542.025C535 550.017 532.228 556.55 526.685 561.622C521.296 566.541 513.212 569 502.433 569H316.037C301.101 569 290.322 565.695 283.701 559.086C277.234 552.477 274 541.794 274 527.038V272.962C274 263.125 275.463 255.132 278.388 248.984C281.314 242.682 285.857 238.147 292.016 235.381C298.329 232.46 306.336 231 316.037 231H497.12C508.053 231 516.137 233.459 521.373 238.378C526.762 243.143 529.457 249.445 529.457 257.284C529.457 265.276 526.762 271.732 521.373 276.651C516.137 281.416 508.053 283.798 497.12 283.798Z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="6"
            />
          </svg>
        </span>
      );

    case 8: // Bye
    case 9: // Out
    default:
      return (
        <span className={wrapperStyle} title="Not named to play">
          <svg
            className="h-full w-full text-red-600 dark:text-red-500"
            viewBox="0 0 800 800"
            fill="none"
          >
            <path
              d="M400.003 0C179.44 0 0 179.438 0 399.997C0 620.557 179.44 799.995 400.003 799.995C620.562 799.995 800 620.557 800 399.997C800 179.438 620.562 0 400.003 0ZM400.003 734.421C215.597 734.421 65.5733 584.403 65.5733 399.997C65.5733 215.595 215.597 65.5733 400.003 65.5733C584.405 65.5733 734.427 215.595 734.427 399.997C734.427 584.403 584.405 734.421 400.003 734.421Z"
              fill="currentColor"
            />
            <path
              d="M446.371 399.995L559.498 286.87C572.303 274.065 572.303 253.307 559.498 240.502C546.695 227.697 525.935 227.699 513.13 240.502L400.003 353.629L286.873 240.499C274.068 227.697 253.31 227.697 240.505 240.499C227.702 253.305 227.702 274.062 240.505 286.868L353.632 399.995L240.502 513.124C227.7 525.93 227.7 546.688 240.502 559.495C246.905 565.895 255.295 569.095 263.686 569.095C272.077 569.095 280.468 565.893 286.87 559.495L400 446.363L513.13 559.495C519.532 565.893 527.923 569.095 536.314 569.095C544.705 569.095 553.095 565.893 559.498 559.495C572.303 546.688 572.303 525.93 559.498 513.124L446.371 399.995Z"
              fill="currentColor"
            />
          </svg>
        </span>
      );
  }
}
